import { http } from './http'
import { auth } from './auth'
import {
  AllTrashSchema,
  BulkTrashResponseSchema,
  BulkUntrashResponseSchema,
  TrashedObjectsSchema,
} from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'
import type { BulkUntrashPayload, BulkEmptyTrashPayload } from '../types'

export const trash = {
  getAll: async (dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deals/${dealId}/all_trash`)
    return parseWithZod(AllTrashSchema, result)
  },

  getTrashedObjects: async (dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deals/${dealId}/trashed_objects`)
    return parseWithZod(TrashedObjectsSchema, result)
  },

  bulkUntrash: async (dealId: number, payload: BulkUntrashPayload) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/deals/${dealId}/bulk_untrash`,
      payload,
      dealId,
    )
    return parseWithZod(BulkUntrashResponseSchema, result)
  },

  bulkEmptyTrash: async (dealId: number, payload: BulkEmptyTrashPayload) => {
    const regionHost = auth.getUserRegionHost()
    await http.post(`${regionHost}/api/deals/${dealId}/bulk_empty_trash`, payload, dealId)
  },

  bulkTrash: async (dealId: number, payload: BulkUntrashPayload) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/deals/${dealId}/bulk_trash`, payload, dealId)
    return parseWithZod(BulkTrashResponseSchema, result)
  },

  deleteUpload: async (uploadId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/uploads/${uploadId}`, dealId)
  },

  deleteVersion: async (versionId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/versions/${versionId}`, dealId)
  },

  deleteMarkup: async (markupId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/markups/${markupId}`, dealId)
  },

  deleteItem: async (itemId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/items/${itemId}`, dealId)
  },

  deleteActionItem: async (actionItemId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/action_items/${actionItemId}`, dealId)
  },

  deleteCategory: async (categoryId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/categories/${categoryId}`, dealId)
  },

  deleteFirm: async (firmId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/firms/${firmId}`, dealId)
  },

  deleteClosingVersion: async (closingVersionId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/closing_versions/${closingVersionId}`, dealId)
  },
}
